// Secondary accessory: tejana hat brim (norteño cowboy hat).
// Used as the rural-norteño variant for Bajitos / La Clica when the card
// is the rural counterpart (e.g., norteño musician, ranch hand).
// Silhouette = tall crown + sharply curled brim + single feather/band.

interface TejanaBrimProps {
  /** Hat body color (typically bone or sand). */
  bodyColor?: string;
  /** Band/feather color. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function TejanaBrim({
  bodyColor = '#c8b89a',    // sand
  accentColor = '#141008',   // sharpie band
  size = 48,
  className,
}: TejanaBrimProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Brim — sharply upturned on both sides (chihuahuense profile) */}
      <path
        d="M2 32 Q12 26 24 28 Q36 26 46 32 Q46 36 24 38 Q2 36 2 32 Z"
        fill={bodyColor}
      />
      {/* Brim shadow underside */}
      <path
        d="M2 32 Q24 38 46 32 Q46 36 24 38 Q2 36 2 32 Z"
        fill="rgba(0,0,0,0.3)"
      />
      {/* Crown — tall, slight teardrop pinch at front */}
      <path
        d="M14 30 Q14 12 24 8 Q34 12 34 30 Z"
        fill={bodyColor}
      />
      {/* Crown highlight — left side */}
      <path
        d="M16 28 Q16 14 22 10"
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Crown shadow — right side */}
      <path
        d="M32 28 Q32 14 26 10"
        stroke="rgba(0,0,0,0.25)"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Hat band — horizontal, dark */}
      <rect x="14" y="26" width="20" height="4" fill={accentColor} />
      {/* Band buckle / decoration */}
      <rect x="22" y="26" width="4" height="4" fill={bodyColor} />
      <rect x="23" y="27" width="2" height="2" fill={accentColor} />
      {/* Teardrop crown pinch — front center */}
      <path
        d="M22 10 Q24 14 26 10"
        stroke={accentColor}
        strokeWidth="1"
        fill="none"
        opacity="0.4"
      />
    </svg>
  );
}
